module.exports = __webpack_public_path__ + "static/media/facebook.299b61ea.png";


//////////////////
// WEBPACK FOOTER
// ./client/socialMediaLogos/facebook.png
// module id = 472
// module chunks = 0